



























import { Component, Vue, Prop } from 'vue-property-decorator';
import AuthenticationService from '@/domain/security/authentication.service';
import UserAvatarComponent from '@/shared/avatars/user/user-avatar.component.vue';
import UserAvatar from '@/shared/avatars/user/user-avatar.class';

@Component({
  components: {
    UserAvatarComponent,
  },
})
export default class TextAreaComment extends Vue {
  @Prop() label!: string;

  @Prop() value!: any;

  @Prop() rows?: number;

  @Prop() readonly?: boolean;

  private user: object = {
    name: AuthenticationService.userLoggedIn().name,
  };

  beforeUpdate() {
    this.commentValue(this.value);
  }

  commentValue(value: string) {
    this.$emit('input', value);
  }
}
